import React from 'react'
import { connect } from 'react-redux'
import './ActionItemContainer.scss'
import { LuxIconBadge } from '@lux/wardrobe-lib'

const ActionItemContainer = (props) => {
    const componentClass = 'smart-new-activity-action-item-container'
    const { title, hasItems, hasBorderTop, showAddLink, linkOnTop } = props

    const onAddItem = () => {
        props.onAddItem()
    }

    return (
        <div
            className={`${componentClass} ${hasItems ? 'with-items' : ''} ${
                hasBorderTop ? 'with-border-top' : ''
            }`}>
            {!linkOnTop && props.children}
            {!showAddLink && (
                <div className={`${componentClass}__title ${linkOnTop ? 'on-top' : ''}`} onClick={onAddItem}>
                    <LuxIconBadge icon="plus" />
                    <span className="link-mini">{title}</span>
                </div>
            )}
            {linkOnTop && props.children}
        </div>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ActionItemContainer)
